import React from 'react'
const ProductData = (props) => {
    const {product_name, product_synonyms} = props;
    let synonymsHtml = '';
    if(product_synonyms.length > 0){
        synonymsHtml = product_synonyms.map((synonymsData,i) =>
            <span key={i} className="badge badge-secondary me-2">
                {synonymsData?.value}
            </span>
        )
    }
    return (
        <>
            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Product name
                    </label>
                    <div className="col-lg-9">
                        <span className="fw-bold fs-6 text-gray-800">
                            {product_name}
                        </span>
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Product synonyms
                    </label>
                    <div className="col-lg-9">
                        {synonymsHtml}
                    </div>
                </div>
            </div>
        </>
    )
}
const ProductList = (props) => {
    const {product_data} = props;
    let productDataHtml = '';
    if( product_data.length > 0 ){
        productDataHtml = product_data.map((productData,i) => 
            <ProductData
                key={i}
                product_name={productData.product_name}
                product_synonyms={productData.product_synonyms}
            />
        )
    }
    return (
        <>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Product List
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 product are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            {productDataHtml}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ProductList